// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__1ZIns","user":"style_user__ticuY"};